<template>
  <div>
    <div class="sac__font-18 med">Active Alerts</div>
    <div v-if="!getCustomerAlertLoading">
      <div v-if="activeAlerts.length > 0">
        <div
          v-for="item in activeAlerts"
          :key="item.alertId"
          class="water-card active-alert margin-top-16"
        >
          <div class="grid-column ai-c jc-s gap-16">
            <div class="alert-circle">
              <span
                v-if="item.type.toLowerCase().includes('water')"
                class="icon-luc-Droplet sac__font-20 f-white"
              />
              <span
                v-else-if="item.type.toLowerCase().includes('heat')"
                class="icon-luc-Sun sac__font-20 f-white"
              />
              <span
                v-else-if="item.type.toLowerCase().includes('cool')"
                class="icon-luc-Snowflake sac__font-20 f-white"
              />
              <span
                v-else
                class="icon-luc-HVAC-Sunflake sac__font-20 f-white"
              />
            </div>
            <div>
              <div class="sac__font-16 med">
                {{ item.title }}
              </div>
              <div class="sac__font-14 n60">
                {{ item.location }}
              </div>
            </div>
          </div>
          <div class="flex-column align-end">
            <div class="sac__font-16 tomato med">
              Last Occurrence: {{ item.lastOccurred }}
            </div>
            <div class="sac__font-14 n60">
              Total Occurrences: {{ item.count }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-alert-card margin-top-16">
        <div class="healthy-circle">
          <img
            src="@shared/assets/img/general/svg/check-white.svg"
            alt="leak"
            class="img-size-16"
          />
        </div>
        <div>No Active Alerts</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'ActiveAlerts',
  computed: {
    ...mapState({
      loadingWaterLeakList: (state) =>
        state.customerDetail.loadingWaterLeakList,
      waterLeakAlertList: (state) => state.customerDetail.waterLeakAlertList,
      customerAllAlerts: (state) => state.customerDetail.customerAllAlerts,
      getCustomerAlertLoading: (state) => state.customerDetail.getCustomerAlertLoading,
      selectedUnit: (state) => state.customerDetail.selectedUnit,
      activeAlerts() {
        const alerts = [];
        this.customerAllAlerts?.active
          ?.filter((alert) => alert.uid === this.selectedUnit.uid 
            && (alert.type === 'Water Detected' 
            || (alert.category === 'Performance' && alert.severity === 'Urgent')))
          .forEach((el) => {
            const { lastOccurred, location, type, occurrence, title } = el;
            alerts.push({
              title,
              location,
              type,
              count: occurrence,
              lastOccurred: moment(lastOccurred).isSame(moment(), 'day')
                ? 'Today'
                : moment(lastOccurred).format('MMM DD, YYYY'),
            });
          });
        return alerts;
      },
    }),
  },
};
</script>

<style scoped lang="scss">
.no-alert-card {
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  background-color: #c6f4d6;
  padding: 1rem;
  border-radius: 8px;
  gap: 16px;
  border: 2px solid $BASIL100;
  .healthy-circle {
    display: grid;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: $BASIL100;
  }
}
.water-card {
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  background-color: $N5;
  padding: 1rem;
  border-radius: 8px;
  &.active-alert {
    border-left: 8px solid $TOMATO100;
  }
  .alert-circle {
    justify-content: center;
    align-items: center;
    display: grid;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color: $N30;
  }
}
</style>
